import { FormGroup, Input } from "reactstrap";
import { FormGroupCommonProp } from "../../../../Type/EcommerceType";

const FormGroupCommon = ({ type, placeholder,formClass,rows }: FormGroupCommonProp) => {
  return (
    <FormGroup className={formClass ? formClass : ""}>
      <Input type={type} placeholder={placeholder} rows={rows} />
    </FormGroup>
  );
};

export default FormGroupCommon;